import axios from 'axios';
import { accessToken } from 'ccs-ui-components';
import { ClearCacheSchema } from '../../../../dashboard/components/utility/schema-defs';

/**
 * @method clearSecretServiceCache
 * @description api function to clear the service secret cache
 * @param
 * @returns status and message
 */
export const clearSecretServiceCache = async () => {
  const resp = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/cache-operation/invalidate?cacheName=ServiceSecrets`, undefined, {
    headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken.value}`
  } });
  // Schema validation for clearcacheschema api
  const apiResponse = ClearCacheSchema.validate(
    resp.data,
    { abortEarly: true }
  );
  if (apiResponse.error) {
    console.log(apiResponse.error, 'error');
    return undefined;
  }
  return resp.data;
};
